module.exports = __webpack_public_path__ + "static/media/orangePattern.1490db59.svg";